<footer class="d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div class="col">Copyright ©2020 all rights reserved</div>
      <div class="col text-right">Jindal Forging Pvt. Ltd.</div>
    </div>
    <div class="row ">
      <div class="col">
        <a class="text-white" href="mailto:rahul@jindalforging.com">RAHUL@JINDALFORGING.COM</a>
      </div>
      <div class="col text-right">
        <a class="text-white" href="tel:+913322106583">+91-33-22106583</a>
      </div>
    </div>
  </div>
</footer>
